export default "__VITE_ASSET__57760659__"